import { MapWithLeftPanelLayout } from "./transportmanager/map-with-left-panel-layout/map-with-left-panel.layout";
import { PagesLayoutComponent } from "./transportmanager/pages-layout/pages-layout.component";
import { ReportsLayoutComponent } from "./transportmanager/reports-layout/reports-layout.component";
import { InformationLayoutComponent } from "./transportmanager/information-layout/information-layout.component";
import { SosMapLayoutComponent } from "./transportmanager/sos-layout/sos-map-layout/sos-map-layout.component";
import { SosListLayoutComponent } from "./transportmanager/sos-layout/sos-list-layout/sos-list-layout.component";
import { MasterLayoutComponent } from "./master/master-layout/master-layout.component";
import { RequestLayoutComponent } from "./transportmanager/request-layout/request-layout.component";
import { RouteRosteringLayoutComponent } from "./transportmanager/route-rostering-layout/route-rostering-layout.component";
import { SupportDeskLayoutComponent } from "./transportmanager/support-desk-layout/support-desk-layout.component";


export const LayoutsDeclaration = [

    PagesLayoutComponent,

    /* Transport Manager */
    MapWithLeftPanelLayout,
    SosListLayoutComponent,
    SosMapLayoutComponent,
    RequestLayoutComponent,
    RouteRosteringLayoutComponent,
    ReportsLayoutComponent,
    InformationLayoutComponent,
    SupportDeskLayoutComponent,

    /* Master */
    MasterLayoutComponent
]